jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

});


  document.addEventListener('DOMContentLoaded', function() {
    var readMoreBtn = document.querySelector('.read-more-btn');
    var readLessBtn = document.querySelector('.read-less-btn');
    var descCollection = document.getElementById('t4s-desc-collection');

    if (readMoreBtn && readLessBtn && descCollection) {
      readMoreBtn.addEventListener('click', function() {
        descCollection.classList.add('expanded');
        readMoreBtn.style.display = 'none';
        readLessBtn.style.display = 'inline';
      });

      readLessBtn.addEventListener('click', function() {
        descCollection.classList.remove('expanded');
        readMoreBtn.style.display = 'inline';
        readLessBtn.style.display = 'none';
      });
    }
  });